import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  currentAlert: any = null;
  constructor(public alertController: AlertController, private translate: TranslateService) {

  }

  public async customAlert(title: string, message: string, onConfirm: () => void, confirmLabel?: string) {
    this.currentAlert = await this.alertController.create({
      header: title,
      // subHeader: subTitle,
      message: message,
      buttons: [{
        text: confirmLabel ? confirmLabel : 'Ok',
        handler: () => {
          if (typeof onConfirm === "function")
            onConfirm();
        }
      }],
      backdropDismiss: false
    })
    await this.currentAlert.present();
  }

  public async show(type: string, message: string) {
    if (message) {
      let header = "";
      switch (type) {
        case "ERROR": {
          header = this.translate.instant("error");
          break;
        }
        case "INFO": {
          header = this.translate.instant("info");
          break;
        }
        default: {
          header = "";
          break;
        }
      }

      this.currentAlert = await this.alertController.create({
        header: header,
        // subHeader: subTitle,
        message: message,
        buttons: ['OK'],
        backdropDismiss: false
      })
      await this.currentAlert.present();
    }
  }

  public async showConfrim(header: any, message: any, onCancel: () => void, onConfirm: () => void, successbtn: any) {
    this.currentAlert = await this.alertController.create({
      header: header,
      message: message,
      backdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant("cancel"),
          role: 'cancel',
          handler: () => {
            if (typeof onCancel === "function")
              onCancel();
          }
        }, {
          text: successbtn,
          handler: () => {
            if (typeof onConfirm === "function")
              onConfirm();
          }
        }
      ]
    });
    await this.currentAlert.present();
  }

  public async showRetry(type: string, message: string, callback: () => void) {
    let header = "";
    switch (type) {
      case "ERROR": {
        header = this.translate.instant("error");
        break;
      }
      case "INFO": {
        header = this.translate.instant("info");
        break;
      }
      default: {
        header = "";
        break;
      }
    }
    this.currentAlert = await this.alertController.create({
      header: header,
      message: message,
      buttons: [
        {
          text: this.translate.instant("retry"),
          handler: () => {
            if (typeof callback === "function")
              callback();
          }
        }
      ],
      backdropDismiss: false
    });

    await this.currentAlert.present();
  }

  hideAll() {
    setTimeout(async () => {
      if (this.currentAlert) {
        this.currentAlert = null;
        return await this.alertController.dismiss();
      }
      return null;
    }, 2000);
  }
}